module.exports = __webpack_public_path__ + "img/calendar-ico.69f1b37f.svg";